module.exports = __webpack_public_path__ + "img/welcome.7ab56a95.jpg";